import request from '@/utils/request'

export default {
  /**
   * 员工列表
   */
  staffs(params) {
    return request.get('/staffs', {
      params
    })
  },

  /**
   * 修改密码
   */
  resetMyPassword(data) {
    return request.post('/staffs/reset/my/password', data)
  }
}
